import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import { CommonModule } from '@angular/common';
import {DrawingDataItem, drawingElements} from "../drawing-on-image/drawingOnImageDrawingElement.model";
import {SummaryFieldModule} from "../../../core/component/summary-field/summary-field.module";
import {TablerIconsModule} from "angular-tabler-icons";
import {ButtonModule} from "../../../core/component/button/button.module";

@Component({
  selector: 'app-drawing-on-image-item-summary-field',
  standalone: true,
  imports: [CommonModule, SummaryFieldModule, TablerIconsModule, ButtonModule],
  templateUrl: './drawing-on-image-item-summary-field.component.html',
})
export class DrawingOnImageItemSummaryFieldComponent implements OnChanges {

  @Input() selectable = true;
  @Input() item: DrawingDataItem;
  @Input() deletable = true;
  @Output() deletedEvent: EventEmitter<DrawingDataItem> = new EventEmitter();
  @Output() selectedEvent: EventEmitter<DrawingDataItem> = new EventEmitter
  iconName: string;

  ngOnChanges(changes: SimpleChanges): void {
    this.iconName = null;
    if (this.item) {
      this.iconName = drawingElements.find(drawingElement => drawingElement.value === this.item.typeValue)?.iconName;
    }
  }

  delete() {
    this.deletedEvent.emit(this.item);
  }

  selected() {
    if (this.selectable) {
      this.selectedEvent.emit(this.item);
    }
  }

}
